module.exports = __webpack_public_path__ + "img/rep-isabella.9be7e067.png";